import { z } from 'zod';
import { ApiError } from '@/lib/api/ApiError';
import { CONSENT_ERROR_CODES, type ConsentErrorCode } from './types';

const ConsentErrorBodySchema = z.object({
  error: z.object({
    code: z.enum(CONSENT_ERROR_CODES),
  }),
});

const AnyErrorCodeBodySchema = z.object({
  error: z.object({
    code: z.string(),
  }),
});

export type ConsentErrorCategory = ConsentErrorCode | 'VALIDATION' | 'NETWORK' | 'UNKNOWN';

export const toConsentErrorCode = (error: unknown): ConsentErrorCategory => {
  if (error instanceof ApiError) {
    const parsed = ConsentErrorBodySchema.safeParse(error.body);
    if (parsed.success) return parsed.data.error.code;

    if (AnyErrorCodeBodySchema.safeParse(error.body).success) return 'UNKNOWN';

    return error.status === 400 ? 'VALIDATION' : 'UNKNOWN';
  }

  if (error instanceof TypeError) return 'NETWORK';

  return 'UNKNOWN';
};
